var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 202.413 202.413",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C0D06"
    },
    d: "M101.422,110.407v92.006H37.049c0,0,0.002-39.459-7.055-70.891L101.422,110.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1C0D06"
    },
    d: "M100.927,110.407v92.006H165.3c0,0-0.002-39.459,7.055-70.891L100.927,110.407z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 86.724,
    y: 152.148,
    style: {
      fill: "#FDCC9B"
    },
    width: 29.395,
    height: 32.922
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCBC85"
    },
    d: "M86.724,156.025c0,0,12.365,7.874,29.395,6.05v-9.928H86.724V156.025z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCBC85"
    },
    cx: 44.337,
    cy: 101.098,
    rx: 14.343,
    ry: 16.364
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FCBC85"
    },
    cx: 158.505,
    cy: 101.098,
    rx: 14.343,
    ry: 16.364
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDCC9B"
    },
    d: "M158.447,69.842c0-24.103-17.637-41.741-57.026-41.741c-39.389,0-57.025,17.637-57.025,41.741 c0,24.104-4.115,87.597,57.025,87.597C162.562,157.439,158.447,93.946,158.447,69.842z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#3B2519"
    },
    cx: 73.645,
    cy: 97.179,
    rx: 6.173,
    ry: 6.761
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 70.954,
    cy: 94.194,
    r: 1.846
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36221E"
    },
    d: "M63.77,82.602c2.919,1.118,7.605-3.798,18.335,0.478c1.956,0.78,3.123-6.668-8.378-6.668 C63.77,76.412,62.007,81.927,63.77,82.602z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#3B2519"
    },
    cx: 129.96,
    cy: 97.179,
    rx: 6.173,
    ry: 6.761
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 127.268,
    cy: 94.194,
    r: 1.846
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#36221E"
    },
    d: "M139.072,82.602c-2.919,1.118-7.606-3.798-18.335,0.478c-1.956,0.78-3.123-6.668,8.377-6.668 C139.072,76.412,140.836,81.927,139.072,82.602z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCBC85"
    },
    d: "M101.421,120.96c-6.099,0-9.773-4.556-9.773-2.352c0,2.205,1.764,6.394,9.773,6.394 c8.011,0,9.774-4.189,9.774-6.394C111.195,116.403,107.52,120.96,101.421,120.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCBC85"
    },
    d: "M101.421,141.23c-2.109,0-3.38-1.576-3.38-0.813c0,0.763,0.609,2.211,3.38,2.211 c2.771,0,3.381-1.448,3.381-2.211C104.802,139.654,103.53,141.23,101.421,141.23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7945E"
    },
    d: "M101.421,135.613c-9.668,0-15.492-3.936-15.492-2.939c0,0.997,2.795,4.924,15.492,4.924 c12.697,0,15.493-3.926,15.493-4.924C116.914,131.676,111.089,135.613,101.421,135.613z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9AA8D"
    },
    cx: 65.707,
    cy: 118.784,
    r: 8.377
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9AA8D"
    },
    cx: 138.164,
    cy: 118.784,
    r: 8.377
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C05371"
    },
    d: "M101.421,165.375v37.038H37.049C37.049,187.421,67.617,165.375,101.421,165.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C05371"
    },
    d: "M101.421,165.375v37.038h64.373C165.794,187.421,135.225,165.375,101.421,165.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C05371"
    },
    d: "M101.421,165.375v37.038h64.373C165.794,187.421,135.225,165.375,101.421,165.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98375E"
    },
    d: "M101.421,165.375c-14.605,0-28.594,4.125-39.787,10.009c8.461,12.851,21.058,23.381,39.787,23.381 c18.73,0,31.327-10.531,39.787-23.381C130.015,169.5,116.026,165.375,101.421,165.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C05371"
    },
    d: "M101.421,165.375c-11.439,0-22.473,2.56-32.112,6.481c6.077,10.609,16.005,20.386,32.112,20.386 c16.107,0,26.035-9.777,32.113-20.386C123.894,167.935,112.861,165.375,101.421,165.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDCC9B"
    },
    d: "M86.724,166.797c0,0,4.3,11.776,14.697,11.776c10.398,0,14.697-11.777,14.697-11.777 S100.87,161.245,86.724,166.797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#98375E"
    },
    d: "M101.421,165.375c-8.766,0-17.297,1.503-25.151,3.96c4.164,8.464,11.695,17.379,25.151,17.379 c13.457,0,20.987-8.916,25.152-17.379C118.719,166.878,110.186,165.375,101.421,165.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C05371"
    },
    d: "M82.642,167.607c2.454,6.538,7.74,15.217,18.779,15.217c11.04,0,16.326-8.679,18.78-15.217 c-6.019-1.405-12.334-2.232-18.78-2.232C94.975,165.375,88.661,166.202,82.642,167.607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDCC9B"
    },
    d: "M116.118,166.796c0,0-1.91,11.777-14.697,11.777c-12.786,0-14.697-11.776-14.697-11.776 s5.732-3.289,14.697-3.289C110.387,163.508,116.118,166.796,116.118,166.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#342620"
    },
    d: "M101.421,0.012V0c-0.073,0-0.141,0.005-0.214,0.006C101.133,0.005,101.065,0,100.991,0v0.012 C34.804,0.266,23.827,57.886,27.787,114.64c3.969,56.879,37.92,76.72,37.92,76.72c-18.517-19.4-13.966-64.198-13.966-64.198 c8.079,12.081,19.213,13.047,19.213,13.047c-21.207-13.673-20.239-60.843-5.247-63.797c14.142-2.786,33.36-16.896,35.5-18.49 c2.139,1.595,21.356,15.704,35.498,18.49c14.992,2.954,15.961,50.124-5.246,63.797c0,0,11.134-0.966,19.214-13.047 c0,0,4.551,44.797-13.968,64.198c0,0,33.952-19.841,37.921-76.72C178.585,57.886,167.609,0.266,101.421,0.012z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.5e5b370f2d72e7f7fa1b21f5431c50e6.svg";
export { ForwardRef as ReactComponent };